module.exports = __webpack_public_path__ + "img/4.8301d811.png";